<template>
  <span :alt="label" :title="label">{{ value }}</span>
</template>

<script>
export default {
  name: 'Emoji',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    label() {
      return this.$emojitranslator.translate(this.value);
    }
  }
};
</script>

<style scoped>
span {
  font-size: 24px;
  margin-right: 8px;
}
@media (max-width: 480px) {
  span {
    font-size: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Emoji.vue